import styles from './Loader.module.scss';

const Loader = ({ className }) => (
  <div className={className}>
    <span className={styles.loader} />
  </div>
);

export default Loader;
